import { CommonModule } from '@angular/common';
import { Component, computed, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';
import { catchError, filter, finalize, forkJoin, map, of, switchMap, tap } from 'rxjs';
import { ModalNames } from 'src/app/common/modal.config';
import { ProfileSidebarComponent } from 'src/app/layout/profile-sidebar/profile-sidebar.component';
import { Services } from 'src/app/services/api.service';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { ModalService } from 'src/app/services/modal.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ReturnTicketsService } from './return-tickets.service';
import { environment } from 'src/environments/environment';
import {InvalidTicket, SelectedEvent} from './return-tickets.model';
import { OrderService } from 'src/app/services/getOrder.service';
import { PaymentComponent } from 'src/app/components/payment/payment.component';
import { NavigationCartService } from 'src/app/components/navigation-cart/navigation.cart.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Order } from 'src/app/common/event.model';
import { CartInfoBoxComponent } from 'src/app/components/cart-info-box/cart-info-box.component';
import { strictEmailValidator } from 'src/app/utils/validators';
import { Router } from '@angular/router';
import { NotificationComponent } from 'src/app/components/notification/notification.component';
import { getNotificationConfig } from 'src/app/utils/notification-config.util';

@Component({
  selector: 'app-return-tickets',
  templateUrl: `${environment.pageFolder}/return-tickets.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/return-tickets.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective, ProfileSidebarComponent, TranslateModule, PaymentComponent, CartInfoBoxComponent, NotificationComponent]
})

export class ReturnTicketsComponent {
  loader: any = document.getElementById('loader-container');
  giveTicketForm: FormGroup;
  membershipBarcodeForm: FormGroup;
  emailTransferTicketForm: FormGroup;
  successfulSelectedEvent: boolean = false;
  availableEvents: any = [];
  errorMessage: string = '';
  errorMessageSelectEvent: string = '';
  showModalConfirmation: boolean = false;
  selectedEvent!: SelectedEvent;
  selectedEventId: any;
  selectedEventName: any;
  selectedEventDate: any;
  availableEventsPerUser: any = [];
  invalidTickets: InvalidTicket[] = [];
  userForTransferTicket: any;
  orderId: number | null = null;
  ticketPdf: string = "";
  url: string = "";
  transferTicketStep: number = 1;
  cartIdTicketEventTransfer: number | null = null;
  cart: Order | null = null;
  //cart: any;
  cartForAnotherTicketIsActive: boolean = false;
  isLoading: boolean = false;
  successMessage: string = '';
  public readonly modalNamesEnum = ModalNames;
  readonly isTransferTicketModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.TransferTicket) ?? false);
  readonly isTransferTicketToEmailModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.TransferTicketToEmail) ?? false);
  showNotification: boolean = false;
  bodyText: string = '';

  private memberToTransferBarcode: number | null = null;

  constructor(
    private formBuilder: FormBuilder,
    public Services: Services,
    private readonly errorMessageService: ErrorMessageService,
    private readonly successMessageService: ErrorMessageService,
    private profileService: ProfileService,
    public modalService: ModalService,
    private readonly returnTicketsService: ReturnTicketsService,
    private readonly orderService: OrderService,
    private navigationCartService: NavigationCartService,
    private readonly destroyRef: DestroyRef,
    private readonly router: Router,
    private readonly translate: TranslateService
  ) {
    this.giveTicketForm = this.formBuilder.group({
      barcodeReturnTicket: ['', [Validators.required]],
      birthDateReturnTicket: ['', [Validators.required]]
    });

    this.membershipBarcodeForm = this.formBuilder.group({
      barcode: ['', [Validators.required]],
    });

    this.emailTransferTicketForm = this.formBuilder.group({
      email: ['', [Validators.required, strictEmailValidator]],
    });
   }

  ngOnInit(): void {
    this.loader.style.display = 'none';
    this.showNotificationModal();

    this.router.events.subscribe((event: any) => {
      if(event.url === '/transfer-tickets') {
        this.getOrder();
      }
    });

    if(environment.configId === "4") {
      this.getSeasonTickets(true);
      this.getOrder();
    }
  }

  getOrder() {
    const lastOrder$ = this.navigationCartService.getLastOrder();

    if (this.orderId || this.navigationCartService.lastOrder) {
      this.orderService.getOrder(this.orderId || this.navigationCartService.lastOrder).subscribe({
        next: (order) => {
          if (order.transactionInfo.ticketDelagation) {
            this.cart = order;
            this.cartIdTicketEventTransfer = order.transactionInfo.ticketDelagationItemId;
            this.transferTicketOpenModal(order.transactionInfo.ticketDelagation);
          }
        },
        error: error => {
          if (error.status === 401) {
            this.Services.logout();
          }
        },
      });
    } else if (lastOrder$ && typeof lastOrder$.pipe === 'function') {
      lastOrder$
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter(response => response.data != null),
          switchMap(response => this.orderService.getOrder(response.data))
        )
        .subscribe({
          next: (order) => {
            if (order.transactionInfo.ticketDelagation) {
              this.cart = order;
              this.cartIdTicketEventTransfer = order.transactionInfo.ticketDelagationItemId;
              this.transferTicketOpenModal(order.transactionInfo.ticketDelagation);
            }
          },
          error: error => {
            if (error.status === 401) {
              this.Services.logout();
            }
          },
      });
    }
  }

  onSubmit() {
    const birthDateReturnTicketInput: any = document.getElementById('date-birth-return-ticket');

    if(!this.giveTicketForm.value.barcodeReturnTicket || !this.giveTicketForm.value.birthDateReturnTicket) {
      if(!this.giveTicketForm.value.barcodeReturnTicket) {
        let barcodeReturnTicketInput: any = document.getElementById('barcode-return-ticket');
        barcodeReturnTicketInput.nextElementSibling!.style.width = "100%";
        barcodeReturnTicketInput.nextElementSibling!.style.backgroundColor = "#ed0000";
      }
      if(!this.giveTicketForm.value.birthDateReturnTicket) {
        birthDateReturnTicketInput.nextElementSibling!.style.width = "100%";
        birthDateReturnTicketInput.nextElementSibling!.style.backgroundColor = "#ed0000";
      }
      this.errorMessage = this.errorMessageService.getErrorMessage("allFieldsRequired");
    } else if(!this.checkbirthDate(birthDateReturnTicketInput.value)) {
      birthDateReturnTicketInput.nextElementSibling!.style.width = "100%";
      birthDateReturnTicketInput.nextElementSibling!.style.backgroundColor = "#ed0000 !important";
      this.errorMessage = this.errorMessageService.getErrorMessage("invalidDate");
    } else {
      this.loader.style.display = 'flex';
      this.availableEvents = [];
      const loadEvents$ = this.returnTicketsService.getListOfEvents(this.giveTicketForm.value.barcodeReturnTicket.trim(), birthDateReturnTicketInput.value.trim()).pipe(
        tap(events => {
          this.availableEvents = events;
          this.errorMessage = '';
        }),
          catchError(error => {
          this.availableEvents = [];
          this.errorMessage = error.message;
          return of([]);
        }),
        finalize(() => {
          this.loader.style.display = 'none';
        })
      );

      forkJoin([
        loadEvents$,
      ]).subscribe(([response]) => {
        setTimeout(() => {
          document.getElementById("select-event")?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100)
      })
    }
  }

  checkbirthDate(birthDateReturnTicket: any) {
    let datebirthCheck = /^(0?[1-9]|[12][0-9]|3[01])[.]((0?[1-9]|1[012])[.](19|20)?[0-9]{2})*$/;

    if(birthDateReturnTicket.match(datebirthCheck)) {
      return true;
    } else {
    return false;
    }
  }

  openModalConfirmation(event: any) {
    this.showModalConfirmation = true;
    this.selectedEventId = event.itemId;
    this.selectedEventName = event.name;
    this.selectedEventDate = event.startTime;
  }

  selectEvent() {
    const body = {
      connectionId: environment.connId,
      barcode: this.giveTicketForm.value.barcodeReturnTicket.trim(),
      id: this.selectedEventId.toString()
    }

    const birthDateReturnTicketInput: any = document.getElementById('date-birth-return-ticket');

    this.Services.delGroupDetailService(body).subscribe({
      next: () => {
        this.successfulSelectedEvent = true;
        this.loader.style.display = 'flex';

        this.returnTicketsService.getListOfEvents(this.giveTicketForm.value.barcodeReturnTicket.trim(), birthDateReturnTicketInput.value.trim()).pipe(
          tap(events =>
            this.availableEvents = events
          ),
          catchError(err => {
            this.errorMessage = err.message;
            return of([]);
          }),
          finalize(() => this.loader.style.display = 'none')
        )
        .subscribe(() => {
          setTimeout(() => {
            document.getElementById("success-container-return-ticket")?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 100);
        });

      },
      error: error => {
        this.errorMessageSelectEvent = "Greška!";
        this.loader.style.display = 'none';
      }
    });
  }

  onInputNewBarcode() {
    this.availableEvents = [];
    this.errorMessage = '';
    this.errorMessageSelectEvent = '';
    this.successfulSelectedEvent = false;
  }

  getSeasonTickets(initialState: boolean = true) {
    this.loader.style.display = 'flex';
    this.isLoading = true;
    this.invalidTickets = [];

    this.profileService
      .getSubsribersTickets(initialState)
      .pipe(
        map((resp: any) => {
          const own = resp.data.own ? [resp.data.own] : [];
          const others = resp.data.others ?? [];
          return [...own, ...others];
        }),

        switchMap(tickets => {
          const { validTickets, missingTickets } = tickets.reduce<{ validTickets: any[]; missingTickets: any[]; }>(
            (acc, ticket) => {
              if (!ticket.groupTicket) {
                return acc;
              }

              if (ticket.ticketOwnerDateOfBirth && ticket.isActive) {
                acc.validTickets.push(ticket);

              } else if (ticket.isActive) {
                acc.missingTickets.push(ticket);
              }

              return acc;
            },
            { validTickets: [], missingTickets: [] }
          );

          this.invalidTickets = missingTickets.map(t => {
            const email = this.translate.instant('COMMON.CONTACT_MAIL');
            const subject = this.translate.instant(
              'RETURN_TICKET.INVALID_SUBJECT',
              { barcode: t.barcode, transId: t.transId }
            );

            return {
              ownerName: t.ticketOwnerName,
              barcode: t.barcode,
              transId: t.transId,
              supportLink: `mailto:${email}?subject=${encodeURIComponent(subject)}`,
            };
          });

          if (validTickets.length === 0) {
            return of([]);
          }

          const calls = validTickets.map(ticket =>
            this.returnTicketsService.getListOfEvents(ticket.barcode, ticket.ticketOwnerDateOfBirth).pipe(
              map(events => ({
                ticketOwnerName: ticket.ticketOwnerName,
                listOfEvents: events
              })),
              catchError(() => of({ticketOwnerName: ticket.ticketOwnerName, listOfEvents: []}))
            )
          );

          return forkJoin(calls);
        }),

        finalize(() => {
          this.loader.style.display = 'none';
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (results) => {
          this.availableEventsPerUser = results.filter(result => result.listOfEvents?.length > 0);
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.loader.style.display = 'none';
        }
    });

  }

  transferTicketOpenModal(event: any) {
    this.selectedEvent = event;
    this.errorMessage = '';

    if(event.itemId === this.cartIdTicketEventTransfer && this.cart) {
      this.transferTicketStep = 3;
      this.cartForAnotherTicketIsActive = false;
      this.orderId = this.cart.id;
      this.navigationCartService.lastOrder = this.cart.id;
    } else if(this.cartIdTicketEventTransfer && this.cart) {
      this.orderId = this.cart.id;
      this.navigationCartService.lastOrder = this.cart.id;
      this.cartForAnotherTicketIsActive = true;
      this.transferTicketStep = 0;
    } else {
      this.transferTicketStep = 1;
    }

    this.modalService.openModal(ModalNames.TransferTicket);
  }

  transferTicket() {
    this.errorMessage = '';
    if (!this.memberToTransferBarcode) return;
    this.returnTicketsService.transferTicketService(this.selectedEvent.itemId,
      this.userForTransferTicket.profileId, this.memberToTransferBarcode).pipe(
      takeUntilDestroyed(this.destroyRef),
      filter(response => response.data != null),
      switchMap(response => this.orderService.getOrder(response.data, true))
    )
    .subscribe({
      next: (order) => {
        this.cart = order;
        this.orderId = order.id;
        this.navigationCartService.lastOrder = order.id;
        this.cartIdTicketEventTransfer = order.transactionInfo.ticketDelagationItemId;

        this.transferTicketStep = 3;
        this.loader.style.display = 'none';
      },
      error: error => {
        if (error.error.errors[0].code === "ORA-20909") {
          this.errorMessage = this.errorMessageService.getErrorMessage("alreadyHasTicket");
          this.loader.style.display = 'none';

        } else  {
          this.errorMessage = this.errorMessageService.getErrorMessage("error");
          this.loader.style.display = 'none';
        }
      }
    });
  }

  checkMembership() {
    const barcode = this.membershipBarcodeForm.value.barcode;
    if (!barcode) {
      this.membershipBarcodeForm.markAllAsTouched();
      this.errorMessage = this.errorMessageService.getErrorMessage("barcodeRequired");
      return;
    }

    this.loader.style.display = 'flex';
    this.returnTicketsService.validateBarcode(barcode).subscribe({
      next: (response) => {
        this.errorMessage = '';
        this.loader.style.display = 'none';

        if (response.data?.profileId) {
          this.userForTransferTicket = response.data;
          this.memberToTransferBarcode = Number(barcode);
          this.transferTicketStep = 2;
        } else if(!response.success) {
          this.errorMessage = this.errorMessageService.getErrorMessage("invalidBarcode");
        }
      },
      error: (error) => {
        this.errorMessage = this.errorMessageService.getErrorMessage("error");
        this.loader.style.display = 'none';
      }
    });
  }

  getTransactionInPdf(delagationTransId: any, transactionType: string) {
    this.profileService.getTransactionAndOpenPdf(delagationTransId, transactionType, this.loader!);
  }

  openTransferTicketToEmailModal(event: SelectedEvent) {
    this.selectedEvent = event;
    this.errorMessage = '';
    this.successMessage = '';
    this.emailTransferTicketForm.reset({ email: '' });
    this.emailTransferTicketForm.markAsPristine();
    this.emailTransferTicketForm.markAsUntouched();
    this.modalService.openModal(ModalNames.TransferTicketToEmail);
  }

  transferTicketToEmail() {
    this.errorMessage = '';
    this.successMessage = '';
    if (this.emailTransferTicketForm.invalid) {
      this.emailTransferTicketForm.markAllAsTouched();
      this.errorMessage = this.errorMessageService.getErrorMessage("invalidEmailFormat");
      return;
    }

    this.loader.style.display = 'flex';

    this.returnTicketsService.transferTicketToAnotherEmailService(this.selectedEvent.delagationTransId, this.emailTransferTicketForm.value.email).subscribe((Response: any) => {
      let response:any = Response;
      if(response.success) {
        this.emailTransferTicketForm.reset({ email: '' });
        this.successMessage = this.successMessageService.getSuccessMessage("ticketTransferedToEmailSuccess");
      } else {
        this.errorMessage = this.errorMessageService.getErrorMessage("error");
      }

      this.loader.style.display = 'none';
    })
  }

  private showNotificationModal(): void {
    const notificationConfig = getNotificationConfig(this.router.url, 'TRANSFER');
    this.showNotification = notificationConfig.show;
    this.bodyText = notificationConfig.bodyTextKey;
  }
}
